import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { useFormContext } from "react-hook-form";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { Label } from "../ui/label";

type OptionType = {
  label: string;
  value: string;
};

type Props = {
  label: string;
  name: string;
  required?: boolean;
  options: string[] | OptionType[];
  defaultvalue?: any;
  disabled?: boolean;
  className?: string;
  /** When vertical, radio options stack in a column (e.g. surveys, unsubscribe). */
  orientation?: "horizontal" | "vertical";
};

const RhfRadio = ({
  label,
  name,
  defaultvalue,
  required,
  options,
  disabled = false,
  className,
  orientation = "horizontal",
  ...props
}: Props) => {
  const { control } = useFormContext();
  const newOptions =
    options && Array.isArray(options)
      ? typeof options?.[0] == "string"
        ? options.map((opt) => ({ label: opt, value: opt }))
        : options
      : [];

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className || "w-full"}>
          {label && (
            <FormLabel>
              {label}
              {required ? "*" : ""}
            </FormLabel>
          )}
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              value={field.value || ""}
              disabled={disabled}
              className={
                orientation === "vertical"
                  ? "flex flex-col gap-3 items-start"
                  : "flex flex-row gap-6"
              }
            >
              {newOptions.map((opt: any) => (
                <div key={opt?.value} className="flex items-center space-x-2">
                  <RadioGroupItem value={opt?.value} id={`${name}-${opt?.value}`} />
                  <Label
                    htmlFor={`${name}-${opt?.value}`}
                    className="text-sm font-normal cursor-pointer"
                  >
                    {opt.label}
                  </Label>
                </div>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default RhfRadio;

